<template>
  <div>
    <v-flex>
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 sm4 p-t-20>
            <fieldset>
              <legend>Fornecedor Tipo</legend>
              <v-layout row wrap>
                <v-flex col xs12 v-if="model.tipFornecedor == 'J'">
                  <v-switch
                    readonly
                    v-model="model.tipFornecedor"
                    :label="$t('label.pessoaJurica')"
                    color="info"
                    value="J"
                    hide-details
                  ></v-switch>
                </v-flex>

                <v-flex col xs12 v-else>
                  <v-switch
                    readonly
                    v-model="model.tipFornecedor"
                    :label="$t('label.pessoaFisica')"
                    color="info"
                    value="F"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>
          <v-flex xs12 sm3 p-t-20>
            <fieldset>
              <legend>Nacionalidade</legend>
              <v-layout row wrap>
                <v-flex col xs12 v-if="model.flagEstrangeiro == '0'">
                  <v-switch
                    readonly
                    v-model="model.flagEstrangeiro"
                    label="Brasileiro"
                    color="info"
                    value="0"
                    hide-details
                  ></v-switch>
                </v-flex>
                <v-flex col xs12 v-else>
                  <v-switch
                    readonly
                    v-model="model.flagEstrangeiro"
                    label="Estrangeiro"
                    color="info"
                    value="1"
                    hide-details
                  ></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>
          <v-flex xs12 sm5 p-t-20>
            <fieldset>
              <legend>
                Tipo de Cadastro

                <v-menu
                  v-if="
                    model.tipoSolicitacao == 2 &&
                    (this.OldModel.tipoCertificado !=
                      this.model.tipoCertificado ||
                      model.motivoAlteracaoCertificado != '')
                  "
                  v-model="infoMotiVoAlteracao"
                  :nudge-width="200"
                  offset-x
                >
                </v-menu>
              </legend>
              <v-flex xs12>
                <v-radio-group
                  v-model="model.tipoCertificado"
                  :readonly="model.flagEstrangeiro == 1"
                  :rules="validacao.campoObrigatorio"
                  class="mb-0 mt-1"
                  row
                  :hint="
                    ifValueAlterado(
                      model.tipoCertificado,
                      'tipoCertificado',
                      aliasValorCertificado
                    )
                  "
                  persistent-hint
                >
                  <v-radio :label="$t('label.crc')" :value="1"></v-radio>
                  <v-radio :label="$t('label.crs')" :value="2"></v-radio>
                  <v-radio :label="$t('label.candidato')" :value="3"></v-radio>
                </v-radio-group>
              </v-flex>
            </fieldset>
          </v-flex>
        </v-layout>
        <v-layout row></v-layout>
        <v-layout row wrap p-t-20>
          <v-flex xs12 sm4 layout>
            <span style="float: left; padding: 30px 0 0 0" >
              <a v-show="model.isFuncionarioPublico && model.tipFornecedor == 'F'">
                <v-tooltip top>
                  <v-icon class="mx-1" slot="activator" :size="20" color="red"
                    >info</v-icon
                  >

                  <span>Esse CPF pertence a um Servidor Público</span>
                </v-tooltip>
              </a>
            </span>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              disabled
              v-model="model.numCgcFornecedor"
              v-bind:class="{ 'cpf-servidor': model.isFuncionarioPublico && model.tipFornecedor == 'F' }"
              :label="
                model.tipFornecedor == 'J'
                  ? $t('label.cnpj') + ' *'
                  : $t('label.cpf') + ' *'
              "
              v-mask="model.tipFornecedor == 'J' ? maskCnpj : maskCpf"
              :rules="
                model.tipFornecedor == 'J' ? validacao.cnpj : validacao.cpf
              "
              required
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              disabled
              v-model="model.numCgcFornecedor"
              v-bind:class="{ 'cpf-servidor': model.isFuncionarioPublico }"
              :label="
                model.tipFornecedor == 'J'
                  ? $t('label.registro')
                  : $t('label.passaporte')
              "
              persistent-hint
            ></v-text-field>

            <span style="float: center; padding: 0px 0 0 0">
              <a v-show="model.linkProcedimentoSEI">
                <v-tooltip top>
                  <img
                    @click="redirecionaLinkSEI(model.linkProcedimentoSEI)"
                    class="mx-1"
                    slot="activator"
                    style="height: 20px; width: 30px"
                    src="../../../assets/logo_sei.png"
                  />
                  <span>Acessar Documentos no SEI</span>
                </v-tooltip>
              </a>
            </span>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              v-model="model.nomFornecedor"
              maxlength="70"
              :label="
                model.tipFornecedor == 'J'
                  ? $t('label.razaoSocial') + ' *'
                  : $t('label.nome') + '*'
              "
              :rules="validacao.campoObrigatorio"
              required
              validate-on-blur
              :hint="ifValueAlterado(model.nomFornecedor, 'nomFornecedor')"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs12>
            <v-text-field
              v-if="model.tipFornecedor == 'J'"
              maxlength="70"
              v-model="model.nomFantasia"
              :label="$t('label.nomeFantasia')"
              :hint="ifValueAlterado(model.nomFantasia, 'nomFantasia')"
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-else
              v-model="model.nomSocial"
              maxlength="70"
              :label="$t('label.nomeSocial')"
              :hint="ifValueAlterado(model.nomSocial, 'nomSocial')"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex
            xs12
            :sm4="model.finalidadeEmpresa === 1"
            :sm6="model.finalidadeEmpresa !== 1"
          >
            <v-select
              v-model="model.categoria"
              :items="listaCategoria"
              item-text="descricao"
              item-value="categoria"
              :label="$t('label.categoria') + ' *'"
              :rules="validacao.campoObrigatorio"
              :hint="ifValueAlterado(model.categoria, 'categoria')"
              :readonly="model.flagEstrangeiro == 1"
              persistent-hint
            ></v-select>
          </v-flex>

          <v-flex
            xs12
            :sm4="model.finalidadeEmpresa === 1"
            :sm6="model.finalidadeEmpresa !== 1"
            p-t-1
            v-if="model.tipFornecedor == 'J'"
          >
            <v-select
              v-model="model.finalidadeEmpresa"
              :items="enumTipoFinalidadeEmpresa"
              item-text="descricao"
              item-value="valor"
              :label="$t('label.finalidadeEmpresa') + ' *'"
              :rules="validacao.finalidadeEmpresa"
              :hint="
                ifValueAlterado(model.finalidadeEmpresa, 'finalidadeEmpresa')
              "
              persistent-hint
              required
            ></v-select>
          </v-flex>

          <v-flex xs12 sm4 v-if="model.finalidadeEmpresa === 1">
            <v-checkbox
              v-model="flagSociedadeAnonima"
              label="Sociedade Anônima?"
            ></v-checkbox>
          </v-flex>
        </v-layout>

        <v-layout
          v-if="model.tipFornecedor == 'F' && documentoRG.docSolicitacao"
          row
        >
          <v-flex xs12 sm12>
            <fieldset>
              <legend>Documento de Identificação</legend>
              <v-layout row wrap>
                <v-flex xs12 sm6 md4 v-if="model.flagEstrangeiro == 0">
                  <v-text-field
                    v-model="documentoRG.docSolicitacao.numDocumentoForn"
                    maxlength="10"
                    :label="$t('label.rg') + ' *'"
                    :rules="ObrigaCampo(validacao.campoRG)"
                    required
                    @keyup="campoRG()"
                    validate-on-blur
                    :hint="
                      ifValueAlteradoSemMask(
                        documentoRG.docSolicitacao.numDocumentoForn,
                        'numDocumentoForn'
                      )
                    "
                    persistent-hint
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="model.flagEstrangeiro == 0">
                  <datePicker
                    v-model="documentoRG.docSolicitacao.datExpedicao"
                    v-mask="maskData"
                    :limitarData="true"
                    :dataDefault="documentoRG.docSolicitacao.datExpedicao"
                    :rules="ObrigaCampo()"
                    :label="$t('label.dataExpedicao') + ' *'"
                    :hint="
                      ifDataAlterado(
                        documentoRG.docSolicitacao.datExpedicao,
                        'datExpedicao'
                      )
                    "
                    persistent-hint
                  />
                </v-flex>
                <v-flex xs12 sm6 md4 v-if="model.flagEstrangeiro == 0">
                  <v-text-field
                    v-model="documentoRG.docSolicitacao.nomOrgaoEmissor"
                    maxlength="40"
                    :label="$t('label.orgaoEmissor') + ' *'"
                    :rules="ObrigaCampo()"
                    required
                    :hint="
                      ifValueAlterado(
                        documentoRG.docSolicitacao.nomOrgaoEmissor,
                        'nomOrgaoEmissor'
                      )
                    "
                    persistent-hint
                  ></v-text-field>
                </v-flex>

                <v-flex inputIcon xs12 sm6 md12 v-show="!upload.novoRG">
                  <TextFieldValidadorDelete
                    :arquivoUpload="documentoRG.docSolicitacao.arquivoUpload"
                    :arquivoUploadSituacao="
                      documentoRG.docSolicitacao.arquivoUploadSituacao
                    "
                    :idMotivoIndeferimentoArquivo="
                      documentoRG.docSolicitacao.idMotivoIndeferimentoArquivo
                    "
                    :idMotivoIndeferimentoArquivo2="
                      documentoRG.docSolicitacao.idMotivoIndeferimentoArquivo2
                    "
                    :idMotivoIndeferimentoArquivo3="
                      documentoRG.docSolicitacao.idMotivoIndeferimentoArquivo3
                    "
                    :codDocumento="'' + documentoRG.docSolicitacao.codDocumento"
                    :idFornecedor="model.numCgcFornecedor"
                    
                    v-on:clear="iconDelete()"
                    v-on:aprovar="validarCampo(documentoRG, 2)"
                    v-on:rejeitar="validarCampo(documentoRG, 1, $event)"
                    :label="$t('label.anexarDocumentoIdentidade')"
                    clearable
                    :hint="
                      ifValueAlterado(
                        documentoRG.docSolicitacao.arquivoUpload,
                        'arquivoUpload'
                      )
                    "
                    persistent-hint
                  ></TextFieldValidadorDelete>
                  <v-dialog v-model="dialog" max-width="355" :persistent="persistent">
                    <v-card>
                      <v-card-title class="headline">Atenção!</v-card-title>
                      <v-form>
                        <v-layout row wrap>
                          <v-flex xs12><br />
                            Deseja excluir o documento?
                          </v-flex>
                        </v-layout><br /><br />
                        <v-layout wrap p-b-10>
                          <v-flex xs12 sm6>
                            <v-btn @click="cancelarDialog()">Não</v-btn>
                          </v-flex>
                          <v-flex xs12 sm6>
                            <v-btn color="info" @click="apagarItem(upload, documentoRG)" :loading="isLoading">Sim</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </v-flex>

                <v-flex xs12 sm6 md12 v-if="upload.novoRG">
                  <uploadFile
                    tamanhoMaximo="20MB"
                    :required="upload.novoRG"
                    :label="$t('label.anexarDocumentoIdentidade') + ' *'"
                    v-model="documentoRG.file"
                    accept=".pdf, .PDF"
                  />
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endEmail"
              maxlength="50"
              :label="$t('label.email') + ' *'"
              :rules="validacao.email"
              required
              validate-on-blur
              :hint="ifValueAlterado(model.endEmail, 'endEmail')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endEmail2"
              maxlength="50"
              :label="$t('label.emailAdicional')"
              :rules="validacao.emailValid"
              required
              :hint="ifValueAlterado(model.endEmail2, 'endEmail2')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endEmail3"
              maxlength="50"
              :label="$t('label.emailAdicional')"
              :rules="validacao.emailValid"
              required
              hint="ifValueAlterado(model.endEmail3,'endEmail3')"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6 md12>
            <v-text-field
              v-model="model.nomContato"
              maxlength="200"
              :label="$t('label.nomeContato') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
              :hint="ifValueAlterado(model.nomContato, 'nomContato')"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              key="telefoneComMask"
              maxlength="14"
              v-model="model.numTelefone"
              :label="$t('label.telefone') + ' *'"
              v-mask="maskTelefone"
              :rules="validacao.campoTelefone"
              required
              validate-on-blur
              :hint="ifValueAlteradoSemMask(model.numTelefone, 'numTelefone')"
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="telefoneSemMask"
              maxlength="14"
              v-model="model.numTelefone"
              :label="$t('label.telefone') + ' '"
              required
              validate-on-blur
              :hint="ifValueAlteradoSemMask(model.numTelefone, 'numTelefone')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              key="celularComMask"
              maxlength="15"
              v-model="model.numCelular"
              :label="$t('label.celular') + ' *'"
              v-mask="maskCelular"
              :rules="validacao.campoCelular"
              required
              validate-on-blur
              :hint="ifValueAlteradoSemMask(model.numCelular, 'numCelular')"
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="celularSemMask"
               maxlength="20"
               minlength="13"
              v-model="model.campoCelularEst"
              :label="$t('label.celular')"
              validate-on-blur
              required
              :hint="ifValueAlteradoSemMask(model.numCelular, 'numCelular')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm4>
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              key="faxComMask"
              maxlength="14"
              v-model="model.numFax"
              :label="$t('label.telefoneAdicional')"
              v-mask="maskTelefone"
              :rules="validacao.campoFax"
              validate-on-blur
              :hint="ifValueAlteradoSemMask(model.numFax, 'numFax')"
              persistent-hint
            ></v-text-field>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              key="faxSemMask"
              maxlength="14"
              v-model="model.numFax"
              :label="$t('label.telefoneAdicional')"
              :hint="ifValueAlteradoSemMask(model.numFax, 'numFax')"
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12 p-t-30>
        <h2 class="headline mb-0 text-primary">
          <strong>{{ $t("label.endereco") }}</strong>
        </h2>
      </v-flex>
    </v-layout>
    <v-flex p-t-30>
      <v-card>
        <v-layout row wrap>
          <v-flex xs8 sm10>
            <v-text-field
              v-model="model.endLogradouro"
              maxlength="50"
              :label="$t('label.logradouro') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
              :hint="ifValueAlterado(model.endLogradouro, 'endLogradouro')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs4 sm2>
            <v-text-field
              v-model="model.endNumero"
              maxlength="6"
              :label="$t('label.numero') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
              :hint="ifValueAlterado(model.endNumero, 'endNumero')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endComplemento"
              maxlength="25"
              :label="$t('label.complemento')"
              :hint="ifValueAlterado(model.endComplemento, 'endComplemento')"
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field
              v-model="model.endBairro"
              maxlength="100"
              :label="$t('label.bairro') + ' *'"
              :rules="ObrigaCampo()"
              required
              validate-on-blur
              :hint="ifValueAlterado(model.endBairro, 'endBairro')"
              persistent-hint
            ></v-text-field>
          </v-flex>


          <!-- CEP com consulta ao webservice -->
          <v-flex xs12 sm6 md4>
           <!--  <div
              v-if="validEventCEP"
              class="msgCEP v-messages v-messages__message theme--light error--text"              
            >
              {{ this.cepNaoEnc }}
            </div> -->
            <v-text-field
              v-if="model.flagEstrangeiro == 0"
              v-model="model.endCep"             
              :label="$t('label.cep') + ' *'"
              v-mask="maskCEP"              
              :rules="validacao.campoCep"
              required
              validate-on-blur
              @blur="viaCEP()"
              @focus="limpaCEP()"
              
            ></v-text-field>

            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              maxlength="15"
              v-model="model.endCepEstrangeiro"
              :label="$t('label.cep')"
              :hint="
                ifValueAlteradoSemMask(
                  model.endCepEstrangeiro,
                  'endCepEstrangeiro'
                )
              "
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              :disabled="model.flagEstrangeiro == 0 ? true : false"
              v-model="model.codPais"
              :items="listaPais"
              :label="$t('label.pais') + ' *'"
              item-text="nomPais"
              item-value="cod_Pais"
              :rules="validacao.campoObrigatorio"
              :hint="ifValueAlterado(model.codPais, 'codPais')"
              persistent-hint
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              v-if="model.flagEstrangeiro == 0"
              v-model="model.codUf"
              :items="listaEstado"
              :label="$t('label.estado') + ' *'"
              item-text="nom_uf"
              item-value="cod_uf"
              :rules="validacao.campoObrigatorio"
              @change="listaCidade = []"
              :hint="ifValueAlterado(model.codUf, 'codUf')"
              persistent-hint
            ></v-autocomplete>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              maxlength="40"
              v-model="model.nomUFEstrangeira"
              :label="$t('label.estado') + ' *'"
              :rules="validacao.campoObrigatorio"
              :hint="
                ifValueAlterado(model.nomUFEstrangeira, 'nomUFEstrangeira')
              "
              persistent-hint
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-autocomplete
              v-if="model.flagEstrangeiro == 0"
              v-model="model.endCidade"
              :items="listaCidade"
              :label="$t('label.cidade') + (model.codUf !== 'DF' ? ' *' : '')"
              item-text="desc_municipio"
              item-value="desc_municipio"
              :rules="validaCidade(model.codUf)"
              :clearable="true"
              :loading="isLoadCombo"
              :search-input.sync="pesquisaCidade"
              :hint="ifValueAlterado(model.endCidade, 'endCidade')"
              persistent-hint
            ></v-autocomplete>
            <v-text-field
              v-if="model.flagEstrangeiro == 1"
              maxlength="50"
              v-model="model.nomCidadeEstrangeira"
              :label="$t('label.cidade')"
              required
              :hint="
                ifValueAlterado(
                  model.nomCidadeEstrangeira,
                  'nomCidadeEstrangeira'
                )
              "
              persistent-hint
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
// eslint-disable-line no-unused-vars import VueTheMask from 'vue-the-mask';
import axios from "axios";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import dominioService from "../../../services/dominioService";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import analiseCampoAlterado from "./components/analiseCampoAlterado";
import TextFieldValidadorDelete from "../../../components/text-field-validador-delete.vue";
export default {
  name: "dados-basicos",
  mixins: [util, analiseCampoAlterado],
  components: {
    TextFieldValidadorDelete
  },
  props: {
    //Propriedades que o objeto recebe como parametro
    model: Object /*Solicitacao atual do Fornecedor*/,
    upload: Object,
    OldModel: Object,
    listaDocFornecSolicitacao: Array,
  },
  computed: {
    //Campos computados
    aliasValorCertificado() {
      switch (this.OldModel.tipoCertificado) {
        case 1:
          return "CRC";
        case 2:
          return "CRS";
        case 3:
          return "Credenciamento";
      }
      return "";
    },
  },
  watch: {
    'model.endCep': function(newVal, oldVal) {
      if (newVal !== oldVal && !this.isCEPFormatted(newVal)) {
        this.model.endCep = this.applyCEPMask(newVal);
      }
      this.atualizarResumoDados(); // Adicionado para atualizar o Resumo de Dados
    },
    
    // Observador existente para o model completo
    model: function(val) {
      if(val.flagSociedadeAnonima === null) {
        val.flagSociedadeAnonima = 0;
        this.flagSociedadeAnonima = false;
      }
      this.carregarFlagSociedadeAnonima(val);

      if (this.model.flagEstrangeiro === "0") {
        this.model.endCep = this.model.endCep.replace("-", "").replace(".", "");  
        this.model.endCep = this.adcionaZeroEsquerda(this.model.endCep, true);
      }
      
      // Atualizar o Resumo de Dados quando o modelo é carregado inicialmente
      this.atualizarResumoDados();
    },
    
    // Novos observadores para os campos que devem ser refletidos no Resumo de Dados
    'model.numCgcFornecedor': function() {
      this.atualizarResumoDados();
    },
    
    'model.nomFornecedor': function() {
      this.atualizarResumoDados();
    },
    
    'model.endLogradouro': function() {
      this.atualizarResumoDados();
    },
    
    'model.endComplemento': function() {
      this.atualizarResumoDados();
    },
    
    'model.endNumero': function() {
      this.atualizarResumoDados();
    },
    
    'model.endBairro': function() {
      this.atualizarResumoDados();
    },
    
    "model.tipFornecedor": {
      handler(newValue, oldValue) {
        if (!newValue) {
          if (oldValue === "J") {
            this.model.tipFornecedor = "F";
          } else {
            this.model.tipFornecedor = "J";
          }
        }
      },
    },
    "model.flagEstrangeiro": {
      handler(newValue, oldValue) {
        if (newValue === "0") {
          this.model.codPais = 1058;
        }

        if (!newValue) {
          if (oldValue === "0") {
            this.model.flagEstrangeiro = "1";
          } else {
            this.model.flagEstrangeiro = "0";
          }
        }
      },
    },
    flagSociedadeAnonima: function (val) {
      this.model.flagSociedadeAnonima = val === true ? "1" : "0";
    },
    "model.finalidadeEmpresa": {
      handler(newValue) {
        if (newValue === 0) {
          this.flagSociedadeAnonima = false;
        }
      },
    },
    // Combinar os dois watchers:
    "model.endCidade": {
      handler(newValue) {
        /*Se houver um novo valor*/
        this.getCidade(newValue);
        this.atualizarResumoDados();
      },
    },
   
    listaDocFornecSolicitacao: {
      handler(newValue) {
        if (newValue) {
          this.documentoRG = this.listaDocFornecSolicitacao.find(
            (x) => x.codDocumento == 140
          );
        }
      },
    },
    pesquisaCidade(newValor, oldValor) {
      this.pesquisaCombo(
        newValor,
        oldValor,
        "listaCidade",
        eval("this.listaCidade"),
        "model.desc_municipio",
        this.getCidade
      );
    },
  },
  created() /*Metodo de start do componente*/ {
    this.getCombosDadosBasicos();
    this.getFinalidadeEmpresa();

    // Carregar os dados iniciais do fornecedor para o Resumo de Dados
    if (this.model && this.model.numCgcFornecedor) {
      this.$store.commit('setFornecedorAtivo', {
        idFornecSolicitacao: this.model.idFornecSolicitacao,
        numCgcFornecedor: this.model.numCgcFornecedor,
        dscRazaoSocial: this.model.nomFornecedor,
        numCep: this.model.endCep,
        dscLogradouro: this.model.endLogradouro,
        dscComplemento: this.model.endComplemento,
        numEndereco: this.model.endNumero,
        dscBairro: this.model.endBairro,
        dscCidade: this.model.endCidade,
        tipoFornecedor: this.model.tipFornecedor
      });
    }
  },
  data() {
    //Declaracao de variaveis
    return {
      dialog: false,
      novoAnexoContratoSocial: false,
      active: 0,
      valid: true,
      repitaSenha: "",
      listaCategoria: [],
      listaPais: [],
      listaEstado: [],
      listaCidade: [],
      pesquisaCidade: null,
      isLoadCombo: false,
      infoMotiVoAlteracao: false,
      enumTipoFinalidadeEmpresa: null,
      documentoRG: Object,
      flagSociedadeAnonima: false,
      baseUrlCEP: "https://viacep.com.br/ws/",
      cepNaoEnc: "CEP não encontrado.",
      validEventCEP: false,
      debounceTimer: null
    };
  },
  methods: {
    //Declaracao de todos os metodos

    iconDelete() {
      this.dialog = true;   
    },
    adcionaZeroEsquerda(cep,isCep){
    
      if(!isCep) return cep;
      if(cep.length < 8 && isCep) return cep.padStart(8, '0')
      return cep;
    },
    cancelarDialog() {
      this.dialog = false;
    },

    apagarItem(up, item) {
      up.novoRG = true;
      item.docSolicitacao.arquivoUpload = null;
      item.docSolicitacao.arquivoUploadSituacao = null;
      item.docSolicitacao.idMotivoIndeferimentoArquivo = null;
      item.docSolicitacao.idMotivoIndeferimentoArquivo2 = null;
      item.docSolicitacao.idMotivoIndeferimentoArquivo3 = null;
      item.docSolicitacao.dtArquivoUploadRejeicao = null;
      item.file = null;
      this.dialog = false;
    },


    ObrigaCampo(tipo) {
      if (tipo) {
        return tipo;
      } else {
        return this.validacao.campoObrigatorio;
      }
    },
    isCEPFormatted(value) {
      // Verifica se o valor está no formato esperado: "12.345-678"
      return /^\d{2}\.\d{3}-\d{3}$/.test(value);
    },
    applyCEPMask(value) {
      // Remove caracteres não numéricos
      const cleanedValue = value.replace(/\D/g, '');

      // Aplica a máscara: "12345678" -> "12.345-678"
      return cleanedValue.replace(/^(\d{2})(\d{3})(\d{3})$/, '$1.$2-$3');
    },
    carregarFlagSociedadeAnonima(model) {
      this.flagSociedadeAnonima = (model.flagSociedadeAnonima === "1" || model.flagSociedadeAnonima === 1);
    },
    // Método para atualizar os dados no Resumo de Dados
    atualizarResumoDados() {
      // Usar debounce para evitar atualizações excessivas durante digitação rápida
      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        // Atualizar o estado Vuex com os dados do fornecedor
        this.$store.commit('setFornecedorAtivo', {
          idFornecSolicitacao: this.model.idFornecSolicitacao || null,
          numCgcFornecedor: this.model.numCgcFornecedor || '',
          dscRazaoSocial: this.model.nomFornecedor || '',
          numCep: this.model.endCep || '',
          dscLogradouro: this.model.endLogradouro || '',
          dscComplemento: this.model.endComplemento || '',
          numEndereco: this.model.endNumero || '',
          dscBairro: this.model.endBairro || '',
          dscCidade: this.model.endCidade || '',
          tipoFornecedor: this.model.tipFornecedor || ''
        });
      }, 300); // 300ms de atraso para evitar execuções desnecessárias
    },
    getCombosDadosBasicos() {
      //carregar os combos da aba de dados basicos
      dominioService.getCombosDadosBasicos().then((response) => {
        /*resposta do servico*/
        this.listaCategoria = response.data.categoria;
        this.listaEstado = response.data.uf;
        this.listaPais = response.data.paises;
      });
    },
    getFinalidadeEmpresa() {
      //pegar as possiveis finalidades de empresa
      dominioService.geEnums().then((response) => {
        /*resposta do servico*/
        this.enumTipoFinalidadeEmpresa = response.data.tipoFinalidadeEmpresa;
      });
    },
    getCidade() {
      //pegar as possiveis cidades para cadastro
      this.isLoadCombo = true;
      // #130751 O valor está sendo passado vazio por causa que na consulta tem que retornar todos para o filtro ser feito pelo campo
      let cidade = { cod_uf: this.model.codUf, desc_municipio: "" };
      dominioService.getCidade(cidade).then((response) => {
        /*resposta do servico*/
        this.listaCidade = response.data; /*dados de retorno*/
        this.isLoadCombo = false;
      });
    },
    limpaCampo(campos) {
      //limpar os campos do documento
      
      if (this.isAlteracao) {
        if (Array.isArray(campos)) {
          campos.forEach((campo) => {
            this.limpaRG(campo);
          });
        } else {
          this.limpaRG(campos);
        }
      }
    },

    baixarArquivo(arquivo) {
      //baixar o documento
      const numCgcFornecedor = this.$verificaPerfilHabilitador()
        ? this.model.numCgcFornecedor.replace(/[\W_]+/g, "")
        : null;
      fornecedorService.baixarArquivo(arquivo, numCgcFornecedor);
    },

    validarCampo(doc, situacao, motivo) {
      const selecao = motivo && typeof motivo === 'object'
        ? motivo
        : { motivoSelecionado: motivo, motivoSelecionado2: null, motivoSelecionado3: null };
      //metodo para aprovar ou rejeitar o documento
      const model = {
        IdDocumentosSolicitacao: doc.docSolicitacao.idDocumentosSolicitacao,
        arquivoUploadSituacao: situacao,
        IdMotivoIndeferimentoArquivo: selecao.motivoSelecionado,
        IdMotivoIndeferimentoArquivo2: selecao.motivoSelecionado2,
        IdMotivoIndeferimentoArquivo3: selecao.motivoSelecionado3,
      };
      
      fornecedorService.aprovarRejeitarArquivoUpload(model).then((response) => {
        /*resposta do servico*/
        doc.docSolicitacao.arquivoUploadSituacao = response.data.arquivoUploadSituacao;
        doc.docSolicitacao.idMotivoIndeferimentoArquivo = response.data.IdMotivoIndeferimentoArquivo;
        doc.docSolicitacao.idMotivoIndeferimentoArquivo2 = response.data.IdMotivoIndeferimentoArquivo2;
        doc.docSolicitacao.idMotivoIndeferimentoArquivo3 = response.data.IdMotivoIndeferimentoArquivo3;
        doc.docSolicitacao.dtArquivoUploadRejeicao = response.data.dtArquivoUploadRejeicao;

        if (situacao === 1) {
          this.$toasted.success(
            this.$t("messages.cadastro.rejeitadoComSucesso")
          );
        } else {
          this.$toasted.success(
            this.$t("messages.cadastro.aprovadoComSucesso")
          );
        }
      });
    },

    redirecionaLinkSEI(endereco) {
      //abrir em outra aba o cadastro do procedimento no SEI
      const link = document.createElement("a");
      var regex =
        /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!-]))?/;
      if (regex.test(endereco)) {
        link.href = endereco;
        link.setAttribute("download", endereco);
        link.setAttribute("target", "_blank");
        document.body.appendChild(link);
        link.click();
        return true;
      }
      return false;
    },

    validaCidade(estado){
      return estado !== 'DF' ? this.validacao.campoObrigatorio : [];
    },

    campoRG() {
     this.documentoRG.docSolicitacao.numDocumentoForn = this.documentoRG.docSolicitacao.numDocumentoForn.replace(
       /[^\d]+/g,
        ""
      );
    },

    limpaCEP() {
      this.validEventCEP = false
    },    

    viaCEP() {           
      const setCEP = this.model.endCep.replace("-", "").replace(".", ""); // Removendo máscara de CEP
      const urlCEP = `${this.baseUrlCEP}${setCEP}/json/`;
      
      axios.get(urlCEP).then(resp => {
        const data = resp.data
        if (!data.erro) {
          this.model.endLogradouro = data.logradouro,
          this.model.endBairro = data.bairro,
          this.model.endCidade = data.localidade,
          this.model.codUf = data.uf
        } else {
          this.validEventCEP = data.erro,
          this.model.endLogradouro = null,
          this.model.endBairro = null,
          this.model.endCidade = null,
          this.model.codUf = null
        }
      }).catch(error => {
        console.error(error)
      })
    }
  },
};
</script>

<style>
.inputIcon {
  position: relative;
}

.inputIcon [type="file"] {
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
}

.inputIcon .v-input__append-inner {
  margin-top: 0;
  padding-left: 0;
  text-align: center;
  width: 38px;
}

.inputIcon .v-text-field__slot {
  border-right: 0;
}

.inputIcon .v-input__icon--clear {
  border-radius: 0;
  border-right: 0 none !important;
}

.inputIcon .v-input__icon {
  align-self: center !important;
  min-height: 50px;
  border: solid 1px #eee;
  border-left: none;
  border-bottom: none;
  display: inline-block !important;
  vertical-align: middle !important;
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}

.inputIcon .v-text-field .v-input__icon.v-input__icon--prepend-inner,
.inputIcon .v-input__icon.v-input__icon--prepend {
  border-right: 0;
  text-align: center;
}

.inputIcon .v-text-field .v-input__prepend-inner,
.inputIcon .v-text-field .v-input__prepend-outer {
  padding-right: 0;
  border-left: 1px solid #eee;
  border-right: 0 none;
  padding: 0;
  width: 50px;
  margin: 0;
}

.inputIcon .v-text-field .v-input__prepend-outer {
  padding-right: 0;
  border-left: 1px solid #eee;
  border-bottom: 1px solid #eee;
  border-right: 0 none;
  padding: 0;
  width: 50px;
  margin: 0;
}

.inputIcon .v-input__icon--prepend .material-icons.theme--light {
  color: #4caf50 !important;
}

.inputIcon .v-input__icon--prepend-inner .material-icons.theme--light {
  color: #d50000 !important;
}
.v-messages__message {
  font-family: "gotham_boldregular";
}

.inputIcon .v-icon {
  padding: 13px 0 0 0;
}

.msgCEP {
  position: absolute;
  top: 161px;
}
</style>
